// extracted by mini-css-extract-plugin
export default {"panel":"PolicyPanel_panel__BTPBn","header":"PolicyPanel_header__FRRnv","icon":"PolicyPanel_icon__+3Uxj","title":"PolicyPanel_title__TxDEt"};